import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { fonts } from 'styles/fonts';

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    fontFamily: fonts.neue,
  }

}));

export default useStyles;
